import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { SupportIssueTopCardContentProps } from "models/propTypes/supportIssuePropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { EntityTopCardContent } from "components/common";
import useQuickActions from "../actions/useMessageQuickActions";
import SupportCaseTopCardParticipants from "./topCardParticipants";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { SupportService } from "services";

const SupportIssueTopCardContent: React.FC<SupportIssueTopCardContentProps> = (props) => {
  const { supportIssue, reloadHandler, statusIndicatorDisplayType } = props;

  const quickActions = useQuickActions(supportIssue, reloadHandler);

  const receivedAt = LocalizationHelperInstance.getFormattedDate(SupportService.getLatestCommentDate(supportIssue!));

  // The state is the customer's perspective, so a byrå member reads it the other way round: AtSupport on their
  // own case is incoming for them, AtCustomer means they have answered. Same rule as the status tag colour.
  const isViewersTurn = supportIssue.isViewerAgencyMember
    ? supportIssue.state === WintSuperkollAPIModel.SupportIssueState.AtSupport && supportIssue.isOwnedByAgency
    : supportIssue.state === WintSuperkollAPIModel.SupportIssueState.AtCustomer;

  return supportIssue.state !== WintSuperkollAPIModel.SupportIssueState.Closed ? (
    <EntityTopCardContent
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Message)}
      descriptionHeadingTwo={supportIssue.title}
      descriptionheadingThree={<SupportCaseTopCardParticipants supportIssue={supportIssue} />}
      footerText={`${LocalizationHelperInstance.getFormattedMessage(
        isViewersTurn ? TranslationKeys.Common.Incoming2 : TranslationKeys.SupportIssue.Replied
      )}: ${receivedAt}`}
      quickActions={quickActions}
      statusIndicatorDisplayType={
        statusIndicatorDisplayType ?? (isViewersTurn ? StyleEnums.DisplayType.Info : StyleEnums.DisplayType.None)
      }
    />
  ) : (
    <EntityTopCardContent
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Message)}
      descriptionHeadingTwo={supportIssue.title}
      descriptionheadingThree={<SupportCaseTopCardParticipants supportIssue={supportIssue} />}
      footerText={`${LocalizationHelperInstance.getFormattedMessage(
        supportIssue.isLocked ? TranslationKeys.SupportIssue.State_StangtForSvar : TranslationKeys.SupportIssue.Solved
      )}: ${LocalizationHelperInstance.getFormattedDate(supportIssue.stateChangedTimestamp)}`}
      statusIndicatorDisplayType={supportIssue.isLocked ? StyleEnums.DisplayType.None : StyleEnums.DisplayType.Success}
    />
  );
};

export default SupportIssueTopCardContent;
